var _rect, _g, _rect2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEndAndAccept(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 71,
    viewBox: "0 0 74 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 47.564,
    height: 40.7904,
    rx: 20.3952,
    fill: "#DC362E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_250_236)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.3184,
    y: 20.4663,
    width: 28.2432,
    height: 28.5579,
    rx: 14.1216,
    transform: "rotate(135 44.3184 20.4663)",
    fill: "#DC362E"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_250_236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3057 23.978L11.1531 21.8254C10.9525 21.6264 10.7952 21.3881 10.6913 21.1258C10.5873 20.8636 10.5391 20.5831 10.5496 20.3023C10.5602 20.0216 10.6293 19.7468 10.7524 19.4956C10.8756 19.2444 11.0502 19.0222 11.2651 18.8434C13.6886 16.8996 16.5406 15.5566 19.592 14.9221C22.4082 14.3092 25.3317 14.3254 28.1549 14.9696C31.2261 15.6422 34.1036 17.0271 36.5545 19.012C36.7706 19.1927 36.9473 19.416 37.0732 19.6677C37.1991 19.9194 37.2715 20.194 37.2858 20.474C37.3001 20.754 37.256 21.0332 37.1563 21.2939C37.0565 21.5547 36.9034 21.7912 36.7065 21.9884L34.5777 24.1173C34.2367 24.4651 33.7795 24.6756 33.2913 24.7097C32.8031 24.7438 32.3173 24.599 31.9242 24.3024C31.1455 23.7033 30.3025 23.1936 29.4112 22.7828C29.0589 22.6215 28.7592 22.363 28.5474 22.0381C28.3357 21.7132 28.2209 21.3354 28.2166 20.9495L28.2065 19.137C25.4 18.3508 22.4416 18.3345 19.6436 19.0896L19.6536 20.9021C19.6536 21.2879 19.543 21.6645 19.3348 21.9871C19.1267 22.3097 18.8297 22.5648 18.4792 22.7223C17.5925 23.1232 16.755 23.6236 15.9829 24.214C15.589 24.5096 15.0986 24.6488 14.605 24.6053C14.1114 24.5618 13.649 24.3385 13.3057 23.978Z",
    fill: "white"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.936,
    y: 27.2432,
    width: 49.564,
    height: 42.3409,
    rx: 21.1704,
    fill: "#2EDC35",
    stroke: "#374249",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.554 54.0848L58.554 57.1595C58.5552 57.445 58.4967 57.7275 58.3824 57.989C58.268 58.2506 58.1003 58.4854 57.89 58.6783C57.6796 58.8713 57.4313 59.0182 57.1609 59.1096C56.8905 59.2011 56.604 59.2351 56.3197 59.2094C53.1659 58.8667 50.1364 57.789 47.4747 56.0629C44.9983 54.4893 42.8988 52.3898 41.3252 49.9134C39.5931 47.2396 38.5152 44.1954 38.1787 41.0274C38.1531 40.744 38.1868 40.4583 38.2776 40.1886C38.3685 39.9189 38.5145 39.6711 38.7063 39.4609C38.8982 39.2507 39.1317 39.0828 39.392 38.9678C39.6523 38.8529 39.9337 38.7933 40.2183 38.7931L43.2931 38.7931C43.7905 38.7882 44.2727 38.9643 44.6498 39.2886C45.0269 39.613 45.2733 40.0634 45.3429 40.5559C45.4727 41.5399 45.7133 42.5061 46.0603 43.4359C46.1982 43.8028 46.2281 44.2015 46.1463 44.5847C46.0646 44.968 45.8747 45.3198 45.5991 45.5985L44.2975 46.9001C45.7565 49.4661 47.881 51.5906 50.447 53.0496L51.7486 51.748C52.0273 51.4724 52.3791 51.2825 52.7624 51.2008C53.1456 51.119 53.5443 51.1489 53.9112 51.2868C54.841 51.6338 55.8072 51.8744 56.7912 52.0042C57.289 52.0745 57.7437 52.3252 58.0688 52.7088C58.3938 53.0925 58.5665 53.5821 58.554 54.0848Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_250_236"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.3184,
    y: 20.4663,
    width: 28.2432,
    height: 28.5579,
    rx: 14.1216,
    transform: "rotate(135 44.3184 20.4663)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_250_236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.0855,
    height: 24.3539,
    fill: "white",
    transform: "translate(41.0581 20.5068) rotate(135)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndAndAccept);
export default __webpack_public_path__ + "static/media/endAndAccept.1429e61a7dd085df41fae73af8d364d4.svg";
export { ForwardRef as ReactComponent };